import { useCallback } from 'react';
import { TableColumnFilter } from '@economic/taco';
import parseFilters from '~/app/shared/table3tools/utils/parseFilters';
import { FilterParamFactory } from '~/app/shared/table3tools/types';

export default function useDefaultFilterParamFactory<T>(
    searchAccessorMap?: Extract<keyof T, string>[],
    staticFilters?: TableColumnFilter[]
): FilterParamFactory {
    return useCallback(
        (filters: TableColumnFilter[], search, excludeSearch) => {
            const filteredSearchAccessorMap =
                searchAccessorMap !== undefined && excludeSearch !== undefined
                    ? searchAccessorMap.filter(accessor => !excludeSearch.includes(accessor))
                    : searchAccessorMap;

            const params = parseFilters<T>(filters.concat(staticFilters ?? []), filteredSearchAccessorMap, search);
            if (!params) {
                return '';
            }

            return `filter=${params}`;
        },
        [searchAccessorMap, staticFilters]
    );
}
